import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import React, { useMemo } from 'react'

export type PolicyDebugSource = 'item_policy'
export type PolicyDebugVertical = 'hotel' | 'flight' | 'car_hire'
export type PolicyDebugSurface = 'budget' | 'offer_credit'

interface Props {
  source: PolicyDebugSource
  vertical: PolicyDebugVertical
  surface: PolicyDebugSurface
  primaryData: unknown
  cacheKey?: string
  employeeIds?: Array<string>
}

function formatDebugData(data: unknown): string {
  try {
    return JSON.stringify(data, null, 2)
  } catch {
    return String(data)
  }
}

export default function BusinessTravellerPolicyDebugModal(props: Props) {
  const {
    source,
    vertical,
    surface,
    primaryData,
    cacheKey,
    employeeIds,
  } = props

  const title = useMemo(() => {
    return `Debug — item policy (${vertical} ${surface.replace('_', ' ')})`
  }, [surface, vertical])

  return (
    <Modal title={title} size="L">
      <Group direction="vertical" gap={16}>
        {cacheKey && <BodyText variant="medium">Cache key: {cacheKey}</BodyText>}
        {employeeIds && employeeIds.length > 0 && (
          <BodyText variant="medium">Employee IDs: {employeeIds.join(', ')}</BodyText>
        )}
        <Group direction="vertical" gap={8}>
          <BodyText variant="large" weight="bold">Primary ({source})</BodyText>
          <pre style={{ maxHeight: 240, overflow: 'auto', fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {formatDebugData(primaryData)}
          </pre>
        </Group>
      </Group>
    </Modal>
  )
}
